var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({staticClass:"nav-button",attrs:{"text":"","tile":""},on:{"click":_vm.navigateToRoute}},'v-btn',_vm.$attrs,false),[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }